import { render, staticRenderFns } from "./AboutApproval.vue?vue&type=template&id=fe209ee4&"
import script from "./AboutApproval.vue?vue&type=script&lang=js&"
export * from "./AboutApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports